import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from "pinia";
import { registerLicense, validateLicense } from '@syncfusion/ej2-base';
import browser from 'browser-detect';
import { store } from '@common/store/store';
import { router } from '@common/router/router.js';
import { errorHandler } from '@common/errorHandler/errorHandler';
import { uStore, uStoreObj } from '@common/userStore';
import routerCmp from '@common/router/router.vue';
import { ddStoreFilter } from "@common/ddStore";
import notSupportedBrowser from "@common/notSupportedBrowser";

// ams
import amsLogin from "@components/ams/amsLogin";

// devDash
import devDash from "@components/devDash/devDash";
import devDashLogin from "@components/devDash/devDashLogin";

// ecDashboard
import ecDashboardComponent from "@ecDashboard/ecDashboard";

// importExport
import importExport from "@components/importExport/importExport";

// recruiterBridge
import recruiterBridgeComponent from "@components/recruiterBridge/recruiterBridge";

// rmsLogin
import rmsLogin from "@components/rms/rmsLogin";

// signinCmp
import signinCmp from '@signin/signin.vue';

// vms
import vms from "@components/vms/vms";
import vmsLogin from "@components/vms/vmsLogin";

// vueBridge
import vueBridgeCmp from '@components/vueBridge/vueBridge';
import { library } from "@common/library/library";
import { navigationStore } from "@common/navigation/navigationStore";

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

let tmpBrowser = browser();
let isOldBrowser = false;
let version = parseFloat(tmpBrowser.versionNumber) || false;
let isUnit = parseInt(getParameterByName('unit'), 10);
if (typeof navigator !== 'undefined' && navigator !== null && typeof navigator.webdriver !== 'undefined') {
    isUnit = navigator.webdriver ? 1 : 0;
}

if (version && isUnit !== 1) {
    switch (tmpBrowser.name) {
        case "safari":
            if (version < 14) {
                isOldBrowser = true;
            }
            break;
        case "chrome":
            if (version < 102) {
                isOldBrowser = true;
            }
            break;
        case "firefox":
            if (version < 91) {
                isOldBrowser = true;
            }
            break;
    }
}

if (typeof USE_NEW_VUE_MODULES !== 'undefined' && USE_NEW_VUE_MODULES) {
    // 30.*.* ORg4AjUWIQA/Gnt3VVhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5VdUVjUX5adHdTRWNdWkd+
    // 31.*.* Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9ccnVTRGdcV0dwW0NWYEA=
    registerLicense('Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9ccnVTRGdcV0dwW0NWYEA=');
} else {
    registerLicense('ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9RdkZiWH9acXFST2dd');
}
/*
* when syncfusion modules use different versions (e.g. "@syncfusion/ej2-vue-charts": "22.1.36", "@syncfusion/ej2-vue-grids": "~22.2.9")
* "@syncfusion/ej2-base" is loading for 22.1.36 and 22.2.9 versions, and from now on project have 2 different validate-lic.js in folowing folders:
* 1) node_modules/@syncfusion/ej2-base/src/validate-lic.js for the "@syncfusion/ej2-vue-grids": "~22.2.9"
* 2) node_modules/@syncfusion/ej2-vue-charts/node_modules/@syncfusion/ej2-base/src/validate-lic.js for the "@syncfusion/ej2-vue-charts": "22.1.36"
*
* registerLicense is executed for node_modules/@syncfusion/ej2-base/src/validate-lic.js only,
* but validateLicense function will be executed only when grid will be rendered on the page,
* as a result licence warning will be shown when only charts are rendered on the page.
*
* To prevent this behaviour we should manually execut validateLicense function, as a result window.syncfusion.isLicValidated will be set to true
* and validate-lic.js from the chart will not validate the license
* */
validateLicense();
let fromLocalhost = typeof FROM_LOCALHOST !== 'undefined' ? FROM_LOCALHOST : false;

if (window.location.search.indexOf('repeat') > -1 && window.location.search.indexOf('project') > -1) {
    if (typeof VUE_PROJECT_NAME !== 'undefined') {
        VUE_PROJECT_NAME = getParameterByName('project');
        IS_REPEATER = true;
        FROM_LOCALHOST = true;
        SDS_URL = "https://dev.samaritan.com/custom/";
    }
    switch (VUE_PROJECT_NAME) {
        case 'ams':
            PROJECTS_URL = "http://dev.samaritan.com/";
            PROJECT_NAME = 'ams';
            break;
        case 'rms':
            PROJECTS_URL = "http://dev.samaritan.com/";
            PROJECT_NAME = 'rms';
            break;
        case 'vms':
        case 'coordinator':
            PROJECTS_URL = "http://dev.samaritan.com/";
            PROJECT_NAME = 'coordinator';
            baseWindow = 'System_06f307312fb68486df7917bf46d8f4f7';
            window.name = baseWindow;
            break;
        case 'signin':
            PROJECTS_URL = "http://localhost";
            PROJECT_NAME = 'signin';
            THE_CUSTOMER = 'DEV';
            break;
        case 'importExport':
            PROJECTS_URL = "http://localhost/";
            PROJECT_NAME = 'coordinator';
            break;
        case 'devDash':
            PROJECTS_URL = window.location.search.indexOf('isprod') > -1
                ? "https://devdash.samaritan.com/"
                : "https://devdashqa.samaritan.com/";
            SDS_URL = PROJECTS_URL + "custom/";
            IS_DEVDASH_QA = SDS_URL.indexOf('devdashqa') !== -1;
            PROJECT_NAME = 'coordinator';
            break;
        case 'ecDashboard':
            DASHBOARD_LAYOUT_ID = 'layoutContainer';
            PROJECTS_URL = "http://localhost/";
            PROJECT_NAME = 'coordinator';
            break;
    }
}
let app;
let routes;
let rootComponent;
let projectName = typeof VUE_PROJECT_NAME !== 'undefined' ? VUE_PROJECT_NAME : 'vueBridge';
switch (projectName) {
    case 'ams':
        routes = [
            {
                path: '/login',
                props: true,
                component: amsLogin,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['ams']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === '-1')) {
                        location.href = '../ams/index.php';
                        location.reload();
                    } else {
                        next();
                    }
                }
            },
            {
                path: '/',
                props: true,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['ams']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === -1) || errorHandler.state.error) {
                        location.href = '../ams/index.php';
                        location.reload();
                    } else {
                        next('login');
                    }
                }
            }
        ];
        router.addRoutes(routes);
        app = createApp(routerCmp);
        break;
    case 'rms':
        routes = [
            {
                path: '/login',
                props: true,
                component: rmsLogin,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['rms']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === '-1')) {
                        location.href = '../rms/index.php';
                        location.reload();
                    } else {
                        next();
                    }
                }
            },
            {
                path: '/',
                props: true,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['rms']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === -1) || errorHandler.state.error) {
                        location.href = '../rms/index.php';
                        location.reload();
                    } else {
                        next('login');
                    }
                }
            }
        ];
        router.addRoutes(routes);
        app = createApp(routerCmp);
        break;
    case 'vms':
    case 'coordinator':
        routes = [
            {
                path: '/login',
                props: true,
                component: vmsLogin,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['user']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === '-1')) {
                        await navigationStore().init();
                        next('/');
                    } else {
                        next();
                    }
                }
            },
            {
                path: '/',
                props: true,
                component: isOldBrowser ? notSupportedBrowser : vms,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['user']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === -1) || errorHandler.state.error) {
                        await navigationStore().init();
                        next();
                    } else {
                        let query = to.query;
                        query['redirect'] = to.path;
                        router.push({ path: '/login', query: query });
                    }
                }
            },
            {
                path: '/:propEntity',
                props: true,
                component: isOldBrowser ? notSupportedBrowser : vms,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    let loggedUser = await uStore().getLoggedUsers(['user']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === -1) || errorHandler.state.error) {
                        await navigationStore().init();
                        next();
                    } else {
                        let query = to.query;
                        query['redirect'] = to.path;
                        router.push({ path: '/login', query: query });
                    }
                }
            }
        ];
        router.addRoutes(routes);
        app = createApp(routerCmp);
        break;
    case 'signin':
        routes = [
            {
                path: '/',
                props: true,
                component: signinCmp,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    next();
                }
            }
        ];
        router.addRoutes(routes);
        app = createApp(signinCmp);
        break;
    case 'importExport':
        app = createApp(importExport);
        break;
    case 'devDash':
        routes = [
            {
                path: '/login',
                props: true,
                component: devDashLogin,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    uStoreObj.limitSession.init();
                    let loggedUser = await uStore().getLoggedUsers(['user']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === '-1')) {
                        next('/');
                    } else {
                        next();
                    }
                }
            },
            {
                path: '/',
                props: true,
                component: devDash,
                async beforeEnter(to, from, next) {
                    store.state.currentPage = to.path;
                    uStoreObj.limitSession.init();
                    let loggedUser = await uStore().getLoggedUsers(['user']);
                    if (parseInt(loggedUser, 10) || (fromLocalhost && loggedUser === -1) || errorHandler.state.error) {
                        next();
                    } else {
                        next('login');
                    }
                }
            }
        ];
        router.addRoutes(routes);
        app = createApp(routerCmp);
        break;
    case 'ecDashboard':
        app = createApp(isOldBrowser ? notSupportedBrowser : ecDashboardComponent);
        break;
    case 'recruiterBridge':
        app = createApp(isOldBrowser ? notSupportedBrowser : recruiterBridgeComponent);
        break;
    default:
        // eslint-disable-next-line no-case-declarations
        let tmpProps = {};
        if (typeof IS_REPEATER !== 'undefined' && IS_REPEATER) {
            tmpProps['cType'] = getParameterByName('cType');
            tmpProps['cId'] = getParameterByName('cId');
        }
        app = createApp(isOldBrowser ? notSupportedBrowser : vueBridgeCmp, tmpProps);
        break;
}

const pinia = createPinia();
let piniaStoreRequest = {};
/* pinia.use(({ store }) => {
    store.$onAction(({
        name, // name of the action
        store, // store instance, same as `someStore`
        args, // array of parameters passed to the action
        after, // hook after the action returns or resolves
        onError // hook if the action throws or rejects}
    }) => {
        if (store && store['$id']) {
            if (store['excludeActionsFromFreezeDetection'] && store['excludeActionsFromFreezeDetection'].indexOf(name) !== -1) return;
            let storeName = store['$id'];
            let requestIndex = storeName + '/' + name;
            let requestParams;
            try {
                requestParams = JSON.stringify(args);
            } catch (e) {
                // eslint-disable-next-line no-empty
            }
            if (requestParams) {
                if (!piniaStoreRequest[requestIndex]) piniaStoreRequest[requestIndex] = {};
                if (!piniaStoreRequest[requestIndex][requestParams]) piniaStoreRequest[requestIndex][requestParams] = 0;
                piniaStoreRequest[requestIndex][requestParams]++;
                if (piniaStoreRequest[requestIndex][requestParams] > 100) {
                    setTimeout(() => {
                        errorHandler.handle("Browser freeze!!! Caused by '" + storeName + "' store in '" + name + "' function.");
                    }, 1000);
                }
                setTimeout(() => {
                    piniaStoreRequest[requestIndex][requestParams] = 0;
                }, 10000);
            }
        }
    });
}); */
window.pinia = pinia;

const importAll = function (r) {
    r.keys().forEach(r);
};
importAll(require.context('@components/', true, /\.js$/));
/* import all components */
importAll(require.context('@components/', true, /^((?!syncfusion).)*\.vue$/i));
const componentContext = require.context('@components/', true, /^((?!syncfusion).)*\.vue$/i, 'lazy');
const componentsExeptions = ['control'];
let includeFunc = function (componentFilePath, app) {
    if (!componentFilePath.split('/').some((e) => componentsExeptions.indexOf(e) !== -1)) {
        const componentName = componentFilePath.split('/').pop().split('.')[0];
        app.component(componentName, defineAsyncComponent(() => componentContext(componentFilePath)));
    }
};

componentContext.keys().forEach((componentFilePath) => includeFunc(componentFilePath, app));

switch (projectName) {
    case 'ams':
        rootComponent = app.use(store)
            .use(pinia)
            .use(router)
            .mount("#ams");
        break;
    case 'rms':
        rootComponent = app.use(store)
            .use(pinia)
            .use(router)
            .mount("#rms");
        break;
    case 'vms':
    case 'coordinator':
        rootComponent = app.use(store)
            .use(pinia)
            .use(router)
            .mount("#vms");
        break;
    case 'signin':
        rootComponent = app.use(store)
            .use(pinia)
            .use(router)
            .mount("#signin");
        break;
    case 'importExport':
        rootComponent = app.use(store)
            .use(pinia)
            .mount("#importExport");
        break;
    case 'devDash':
        rootComponent = app.use(store)
            .use(pinia)
            .use(router)
            .mount("#devDash");
        break;
    case 'ecDashboard':
        rootComponent = app.use(store)
            .use(pinia)
            .mount("#ecDashboard");
        break;
    case 'vueBridge':
        rootComponent = app.use(store)
            .use(pinia)
            .mount("#vueBridge");
        break;
    case 'recruiterBridge':
        rootComponent = app.use(store)
            .use(pinia)
            .mount("#recruiterBridge");
        break;
}

app.config.globalProperties.$filters = {
    ddStore: ddStoreFilter
};
app.config.errorHandler = function (error) {
    if (!errorHandler.get("error")) errorHandler.handle(error);
};

app.config.warnHandler = function (msg, vm, trace) {
    // `trace` is the component hierarchy trace
};
let turnOnCheckDynamicTemplate = true;
if (turnOnCheckDynamicTemplate) {
    app.realComponent = app.component;
    // global wrapper for dynamic templates, which trying to fix them
    app.component = function (name, component) {
        if (component) {
            if (typeof component?.template === 'string') {
                component.template = library.checkTemplate(component.template, name);
            }
            return app.realComponent(name, component);
        }
        return app.realComponent(name);
    };
}
window['vueApp'] = app;
window['vueCreateApp'] = createApp;
